import { SdgId } from '@upright/common/model/output/scores/sdg-alignment/types';
import { Valence } from '@upright/common/model/types';
import { BranchingElbowConnector } from '@upright/ui/common/upright/core/impact-lens-profile/common/components/connectors/branching-elbow-connector';
import { valenceToSide } from '@upright/ui/common/upright/core/impact-lens-profile/common/utils';
import { useCarouselLayout } from '@upright/ui/common/upright/core/impact-lens-profile/context';
import { sdgLensLayout } from '@upright/ui/common/upright/core/impact-lenses/sdg/common/layout';
import { connectionPointForDataAreaBoundsAtValence } from '@upright/ui/common/upright/core/impact-lenses/sdg/common/layout/layout-utils';
import { getImpactCategoriesForSdg } from '@upright/ui/common/upright/core/impact-lenses/sdg/common/sdg-mapping';
import { useSdgLensContext } from '@upright/ui/common/upright/core/impact-lenses/sdg/common/use-sdg-lens-context';
import { useSdgUnitsMode } from '@upright/ui/common/upright/model/output/scores/sdg-alignments/use-sdg-unit-mode';

import { max } from 'lodash';

interface Props {
  sdgId: SdgId;
  valence: Valence;
}

// function getColor(id: SdgId) {
//   switch (id) {
//     case SdgId._9_Industry_Innovation_and_Infrastructure:
//       return '#FD6925';
//     case SdgId._8_Decent_Work_and_Economic_Growth:
//       return '#A21942';
//     case SdgId._12_Responsible_Consumption_and_Production:
//       return '#BF8B2E';
//   }
//   return 'black';
// }

export function SdgBoxConnector(props: Props) {
  const { sdgId } = props;
  const ctx = useSdgLensContext();
  const baseLayout = useCarouselLayout();
  const [unitsMode] = useSdgUnitsMode();
  if (!ctx) {
    return <></>;
  }
  const data = ctx.data.sdgAlignments;
  if (!data) {
    return <></>;
  }
  const layout = sdgLensLayout(baseLayout, data, unitsMode);

  const impacts = getImpactCategoriesForSdg(sdgId);
  const boxArea = layout.sdgBoxArea(valenceToSide(props.valence), sdgId);
  const startPoint = {
    x: props.valence === Valence.POSITIVE ? boxArea.x1 : boxArea.x2,
    y: boxArea.cy,
  };
  const endPoints = impacts.map(impact => {
    const refArea = baseLayout.impactCenterArea(impact);
    const point = connectionPointForDataAreaBoundsAtValence(refArea, props.valence);
    return point;
  });

  // Code that was used for testing use of different branchpoints, but ended
  // up only making things more messy. Kept for a while for reference
  //
  // const sdgs = getMostAlignedSdgs(data, toSdgAligmentValence(props.valence));
  // const index = sdgs.indexOf(sdgId);
  // const scale = scaleLinear().domain([0, sdgs.length]).range([-30, 30]);
  // const connectors = endPoints.map(endPoint => {
  //   return <SmoothConnector x1={startPoint.x} y1={startPoint.y} x2={endPoint.x} y2={endPoint.y} />;
  // });
  // return <>{connectors}</>

  const midXValues = endPoints.map(point => (point.x + startPoint.x) / 2);
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  const branchX = max(midXValues)!;
  return <BranchingElbowConnector startPoint={startPoint} endPoints={endPoints} branchX={branchX} />;
}
